//손해사정사의 구분
import styles from "../../styles/info/Types.module.css";
import classNames from "classnames/bind";
import typeData from "../../data/type.json";

const cx = classNames.bind(styles);

export default function Types() {
  return (
    <>
      <div className={cx("typesContainer")}>
        <div className={cx("title")}>
          <h4>손해사정사의 구분</h4>
        </div>
        <p className={cx("mainDesc", "box", "reveal")}>
          손해사정사는 법령상
          <span className={cx("highlight")}> 재물 · 차량 · 신체 </span>
          손해사정사로 구분됩니다.
          <br />
          <br />각 자격은 담당할 수 있는 보험사고와 손해평가 범위가 다르며,
          사고의 성격에 따라
          <span className={cx("highlight")}> 적합한 전문 인력 </span>
          이 업무를 수행해야 합니다.
          <br />
          <br />
          으뜸손해사정은 사고 유형과 손해 특성에 맞춘
          <span className={cx("highlight")}> 체계적인 분석 </span>을 통해 보다
          정확한 손해사정 서비스를 제공합니다.
        </p>

        <div className={cx("typeList", "reveal")}>
          {typeData.types.map((item, index) => (
            <div key={index} className={cx("typeCard", "card", "liftUp")}>
              <img src={item.img} alt={item.type} className={cx("typeIcon")} />

              <h5 className={cx("typeTitle")}>{item.type}</h5>
              <p className={cx("typeText")}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
